import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';

const FONT = 'Arial, Helvetica, sans-serif';
let ctx;
const measure = (text, fs) => {
  ctx = ctx || document.createElement('canvas').getContext('2d');
  ctx.font = `500 ${fs}px ${FONT}`;
  return ctx.measureText(text).width + text.length;
};

// Watermark grid: rows alternate name / CPF, every mark is its own <text> (no tile clipping), spacing comes from the
// measured text width, so marks never touch and the whole page stays covered at any zoom
export const WatermarkOverlay = ({ name, cpf, zoom = 1 }) => {
  const ref = useRef(null);
  const [size, setSize] = useState({ w: 0, h: 0 });
  useLayoutEffect(() => {
    const ro = new ResizeObserver(([e]) => setSize({ w: e.contentRect.width, h: e.contentRect.height }));
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  const fs = Math.max(8, 11 * zoom);
  const cpfText = `CPF: ${cpf || 'N/A'}`;
  const marks = useMemo(() => {
    if (!size.w || !size.h) return [];
    const cellW = Math.max(measure(name, fs), measure(cpfText, fs)) + fs * 3;
    const rowH = fs * 2.6;
    const half = Math.hypot(size.w, size.h) / 2 + cellW;
    const out = [];
    for (let r = 0, y = -half; y <= half; r += 1, y += rowH) {
      const shift = (r % 4 >= 2 ? cellW / 2 : 0) - half;
      for (let x = shift; x <= half; x += cellW) out.push({ k: `${r}-${Math.round(x)}`, x, y, t: r % 2 ? cpfText : name });
    }
    return out;
  }, [size, name, cpfText, fs]);
  return (
    <svg ref={ref} data-testid="watermark-overlay" width="100%" height="100%"
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 5, userSelect: 'none', overflow: 'hidden' }}>
      <g transform={`translate(${size.w / 2} ${size.h / 2}) rotate(-35)`} fontSize={fs} fontWeight="500" fontFamily={FONT}
        letterSpacing="1" fill="rgba(180, 30, 30, 0.18)">
        {marks.map((m) => <text key={m.k} x={m.x} y={m.y}>{m.t}</text>)}
      </g>
    </svg>
  );
};
